
import { Loader } from '@googlemaps/js-api-loader'
import { defineComponent } from 'vue'
import {
  mapStyles,
} from '~/components/sections/coverage/map-styles'
export default defineComponent({
  name: 'CharityMap',
  components: {},
  data: () => ({
    map: null as google.maps.Map | null,
    isMapReady: false,
  }),
  async mounted () {
    const loader = new Loader({
      apiKey: this.$config.GOOGLE_MAPS_API_KEY,
      version: 'weekly',
      libraries: ['places'],
    })

    const googleAPI = await loader.load()

    this.map = new googleAPI.maps.Map(this.$refs.locationMap as HTMLElement, {
      zoom: 13,
      minZoom: 8,
      maxZoom: 16,
      center: new googleAPI.maps.LatLng(0.9984, 33.8746),
      styles: mapStyles,
      mapTypeId: 'hybrid',
      mapTypeControl: false,
      streetViewControl: false,
      clickableIcons: false,
      scaleControl: false,
      zoomControlOptions: {
        position: googleAPI.maps.ControlPosition.LEFT_BOTTOM,
      },
      fullscreenControlOptions: {
        position: googleAPI.maps.ControlPosition.RIGHT_BOTTOM,
      },
    })
    // eslint-disable-next-line no-new
    new googleAPI.maps.Marker({
      position: { lat: 0.9984, lng: 33.8746 },
      map: this.map,
      title: 'Nandere',
    })
    this.isMapReady = true
  },
})
